import { call, fork, take, put } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { NetworkStatisticsApi, FacebookPostApi, InstagramPostApi } from '../../api/instances'
import { Severity, EventType } from '@professocial/professocialTypes/types/messageTypes'
import { setMessage } from '../common/common.actions'

import {
  getInstagramPageStatistics, getInstagramPageStatisticsInitiated,
  getFacebookPageStatistics, getFacebookPageStatisticsInitiated, getFacebookPostsInRangeForPage, getFacebookPostsInRangeForPageInitiated, getInstagramPostsInRangeForPage, getInstagramPostsInRangeForPageInitiated,
} from './statistics.user.actions'
import {
  GetFacebookPageStatisticsRequest,
  GetInstagramPageStatisticsRequest,
} from '@3m5/sm_publish-frontend-api/apis/NetworkStatisticsApi'
import { GetFacebookPostsInRangeForPageRequest, GetInstagramPostsInRangeForPageRequest } from '@3m5/sm_publish-frontend-api'

// getFacebookPageStatistics
const getFacebookPageStatisticsWorker = bindAsyncAction(getFacebookPageStatistics)(
  function * (params: GetFacebookPageStatisticsRequest) {
    return yield call([NetworkStatisticsApi, NetworkStatisticsApi.getFacebookPageStatistics], params)
  },
)

function * watchGetFacebookPageStatisticscInitiated () {
  while (true) {
    const action: Action<GetFacebookPageStatisticsRequest> = yield take(getFacebookPageStatisticsInitiated)
    try {
      yield getFacebookPageStatisticsWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:getFacebookPageStatisticsError',
        eventType: EventType.update,
      }))
      console.error('error in watchGetFacebookPageStatisticsInitiated: ', e)
    }
  }
}

// getInstagramPageStatistics
const getInstagramPageStatisticsWorker = bindAsyncAction(getInstagramPageStatistics)(
  function * (params: GetInstagramPageStatisticsRequest) {
    return yield call([NetworkStatisticsApi, NetworkStatisticsApi.getInstagramPageStatistics], params)
  },
)

function * watchGetInstagramPageStatisticsInitiated () {
  while (true) {
    const action: Action<GetInstagramPageStatisticsRequest> = yield take(getInstagramPageStatisticsInitiated)
    try {
      yield getInstagramPageStatisticsWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:getInstagramPageStatisticsError',
        eventType: EventType.update,
      }))
      console.error('error in watchGetInstagramPageStatisticsInitiated: ', e)
    }
  }
}

// getFacebookPostsInRangeForPage
const getFacebookPostsInRangeForPageWorker = bindAsyncAction(getFacebookPostsInRangeForPage)(
  function * (params: GetFacebookPostsInRangeForPageRequest) {
    return yield call([FacebookPostApi, FacebookPostApi.getFacebookPostsInRangeForPage], params)
  },
)

function * watchGetFacebookPostsInRangeForPageInitiated () {
  while (true) {
    const action: Action<GetFacebookPostsInRangeForPageRequest> = yield take(getFacebookPostsInRangeForPageInitiated)
    try {
      yield getFacebookPostsInRangeForPageWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:getFacebookPostsInRangeForPageError',
        eventType: EventType.update,
      }))
      console.error('error in watchGetFacebookPostsInRangeForPageInitiated: ', e)
    }
  }
}

// getInstagramPostsInRangeForPage
const getInstagramPostsInRangeForPageWorker = bindAsyncAction(getInstagramPostsInRangeForPage)(
  function * (params: GetInstagramPostsInRangeForPageRequest) {
    return yield call([InstagramPostApi, InstagramPostApi.getInstagramPostsInRangeForPage], params)
  },
)

function * watchGetInstagramPostsInRangeForPageInitiated () {
  while (true) {
    const action: Action<GetInstagramPostsInRangeForPageRequest> = yield take(getInstagramPostsInRangeForPageInitiated)
    try {
      yield getInstagramPostsInRangeForPageWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:getInstagramPostsInRangeForPageError',
        eventType: EventType.update,
      }))
      console.error('error in watchGetInstagramPostsInRangeForPageInitiated: ', e)
    }
  }
}

export function * statisticsUserSagas () {
  yield fork(watchGetFacebookPageStatisticscInitiated)
  yield fork(watchGetInstagramPageStatisticsInitiated)
  yield fork(watchGetFacebookPostsInRangeForPageInitiated)
  yield fork(watchGetInstagramPostsInRangeForPageInitiated)
}
